import { useState, type FormEvent } from 'react';

export default function NewsletterForm() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setStatus('loading');
    setMessage('');

    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypotValue = (formData.get('website_alt') as string || '').trim();

    if (honeypotValue) {
      setStatus('success');
      setMessage('Thank you for subscribing!');
      setEmail('');
      return;
    }

    formData.delete('website_alt');

    try {
      const response = await fetch('https://readdy.ai/api/form/d9a9bg4nib0mhnm9k29g', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        setMessage('Thank you for subscribing! You will receive updates soon.');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || 'Something went wrong. Please try again.';
        setStatus('error');
        setMessage(serverMsg);
      }
    } catch {
      setStatus('error');
      setMessage('Network error. Please check your connection and try again.');
    }
  };

  return (
    <div>
      <h4 className="font-heading text-base font-semibold text-background-50 mb-2">
        Get Updated Superbuy Spreadsheet Resources
      </h4>
      <p className="text-background-50/50 text-xs mb-4 leading-relaxed">
        Subscribe to receive the latest product guides, shopping tips, and resource updates
      </p>

      <form onSubmit={handleSubmit} data-readdy-form="">
        <div className="honeypot-wrapper">
          <input
            type="text"
            name="website_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
          />
        </div>

        <div className="flex gap-2">
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Your email address"
            required
            className="flex-1 px-4 py-2.5 bg-background-50/10 border border-background-50/20 rounded-lg text-background-50 text-sm placeholder:text-background-50/40 outline-none focus:border-primary-400 transition-colors"
          />
          <button
            type="submit"
            disabled={status === 'loading'}
            className="inline-flex items-center gap-1.5 px-5 py-2.5 bg-primary-500 text-background-50 text-sm font-semibold rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer disabled:opacity-60"
          >
            {status === 'loading' ? (
              <span>Sending...</span>
            ) : (
              <>
                <span>Subscribe</span>
                <i className="ri-arrow-right-line text-sm"></i>
              </>
            )}
          </button>
        </div>

        {status === 'success' && (
          <p className="mt-2 text-accent-400 text-xs">{message}</p>
        )}
        {status === 'error' && (
          <p className="mt-2 text-red-400 text-xs">{message}</p>
        )}
      </form>
    </div>
  );
}